import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import Button from '@material-ui/core/Button';
import { DatePicker, MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core/styles";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
//import FormMethodPayment from './FormMethodPayment';
import BuildXml from '../../../ElectronicBilling/components/BuildXml';

const styles = theme => ({
    date: { 
        width: 400,
        fontFamily: 'Roboto',
        border: 'none',
        fontSize: 13,
        lineHeight: 1.6
    },
});

const renderField = ({
    input, disabled, placeholder, type, meta: { touched, error }, style
  }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above" style={style}>
      <input {...input} placeholder={placeholder} type={type} disabled={disabled}/>
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
  
  renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
  };
  
  renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
  };


  const FormMethodPayment = ({ cash, setCash, card, setCard, check, setCheck, wayToPay, setWayToPay, errors })=>{
    return (<div style={{ display: 'flex', flexDirection: 'column', width: '100%'}} >
              <div style={{ display: 'flex', width: '100%' }}>
                <div className="form__form-group" style={{ width: '100%', marginRight: 20 }}>
                    <span className="form__form-group-label">Efectivo</span>
                    <div className="form__form-group-field">
                        <Field
                            key={`Efectivo`}
                            name={`Efectivo`}
                            component={renderField}
                            type="number"
                            placeholder=""
                            value={cash}
                            onChange={(e)=> setCash(e.target.value)}
                        />
                    </div>
                </div>
                <div className="form__form-group" style={{ width: '100%', marginRight: 20 }}>
                    <span className="form__form-group-label">Cheque</span>
                    <div className="form__form-group-field">
                        <Field
                            key={`check`}
                            name={`check`}
                            component={renderField}
                            type="number"
                            placeholder=""
                            value={check}
                            onChange={(e)=> setCheck(e.target.value)}
                        />
                    </div>
                </div>
                <div className="form__form-group" style={{ width: '100%'}}>
                    <span className="form__form-group-label">Tarjeta</span>
                    <div className="form__form-group-field">
                        <Field
                            key={`card`}
                            name={`card`}
                            component={renderField}
                            type="number"
                            placeholder=""
                            value={card}
                            onChange={(e)=>setCard(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div>
                <span className="form__form-group-error">{errors.hasOwnProperty("total")? errors.total: ""}</span>
            </div>
            {card != ''?
              <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}> 
                <div className="form__form-group" style={{ width: "33%", display: "flex", paddingLeft: 20 }}>
                    <span className="form__form-group-label">forma de pago</span>
                    <div className="form__form-group-field">
                    <Field
                        name="way-to-pay"
                        component={renderSelectField}
                        value={wayToPay}
                        onChange={(event) => {
                            setWayToPay(event);
                        }}
                        options={[
                            { value: 'DEBITO', label: 'DEBITO' },
                            { value: 'CREDITO', label: 'CREDITO' }
                        ]}
                        meta={{ touched: errors.hasOwnProperty("wayToPay"), error: errors.hasOwnProperty("wayToPay")? errors.wayToPay: ""  }}
                    />
                    </div>
                </div>
              </div>: null}
              <div className="form__form-group">
                <span className="form__form-group-label">Total</span>
                  <div style={{ width: '50%', paddingRight: 20 }}>
                      <div class="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                          <input name="total" placeholder="" type="number" value={parseInt(cash !== ""? cash: "0") + parseInt(card !== ""? card: "0") + parseInt(check !== ""? check: "0")} disabled={true}/> 
                      </div>
                  </div>
              </div>
          </div>)
  }


  const TypeForm = ({type, 
                    setType,
                    invoiceList, 
                    costumer, 
                    setCostumer, 
                    costumers, 
                    reason,
                    setReason,
                    numBilling, 
                    setNumBilling, 
                    balance, 
                    setBalance, 
                    observation, 
                    setObservation,
                    documentNumber,
                    setDocumentNumber,
                    cash,
                    setCash, 
                    card, 
                    setCard,
                    check, 
                    setCheck,
                    wayToPay, 
                    setWayToPay,
                    dates,
                    setDates,
                    searchInvoicesCostumer, 
                    searchInvoicesPatient,
                    createDebitNote,
                    errors }) => {
    
    const options = costumers.map(costumer=>{
      return  { value: costumer.id_tercero.toString() , label: costumer.nombre };
    });
    
    const invoiceOptions = invoiceList.map(invoice => {
      console.log(invoice);
      if(type == 'cliente'){
        return { value: invoice.num_fac_ter , label: invoice.num_fac_ter }
      } else if(type === 'paciente') {
        return { value: invoice.num_fac_pac , label: invoice.num_fac_pac }
      }

      
    })

    console.log(invoiceOptions);
    switch (type){
      case 'cliente':
        return (<div className="form">
                  <div className="form__form-group">
                    <span className="form__form-group-label">Clientes</span>
                    <div className="form__form-group-field">
                      <Field
                          key={`select-costumers`}
                          name={`select-costumers`}
                          component={renderSelectField}
                          value={costumer}
                          onChange={(event) => {
                              setCostumer(event);
                          }}
                          options={options}
                      />
                    </div>
                  </div>
                  <div style={{ paddingRight: 5, width: '50%', display: 'flex' }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha desde"
                            views={["year", "month", "date"]}
                            value={dates.start}
                            onChange={(date)=>{
                                setDates({...dates, start: date });
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ marginRight: 10, width: '100%' }}
                        />
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha hasta"
                            views={["year", "month", "date"]}
                            value={dates.end}
                            onChange={(date)=>{
                                setDates({...dates, end: date });
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ width: '100%' }}
                        />
                    </MuiPickersUtilsProvider>
                    
                </div>
                <div style={{ display: 'flex', marginTop: 'auto', marginLeft: '10px'}}>
                  <Button 
                      style={{ margin: 'auto' }}
                      variant="contained" 
                      color="primary" 
                      onClick={() => {
                        searchInvoicesCostumer();
                      }}
                  >
                      Buscar Facturas
                  </Button>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">N° Factura</span>
                    <div className="form__form-group-field">
                    <Field
                        key={`select-invoice-client`}
                        name={`select-invoice-client`}
                        component={renderSelectField}
                        value={numBilling}
                        onChange={(event) => {
                            setNumBilling(event);
                        }}
                        options={invoiceOptions}
                        meta={{ touched: errors.hasOwnProperty("numBilling"), error: errors.hasOwnProperty("numBilling")? errors.numBilling: "" }}
                    />
                    </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Motivo</span>
                  <div className="form__form-group-field">
                  <Field
                      key={`select-reason`}
                      name={`select-reason`}
                      component={renderSelectField}
                      value={reason}
                      onChange={(event) => {
                          setReason(event);
                      }}
                      options={[
                        { value: 'AYUDA DIAGNOSTICA NO PERTINENTE' , label: 'AYUDA DIAGNOSTICA NO PERTINENTE'},
                        { value: 'CONCILIACION AUDITORIA MEDICA' , label: 'CONCILIACION AUDITORIA MEDICA'},
                        { value: 'COPAGO NO COBRADO O NODES CONTADO' , label: 'COPAGO NO COBRADO O NODES CONTADO'},
                        { value: 'DESCUENTO 25% POR FALTA DE LECTUA O REPO' , label: 'DESCUENTO 25% POR FALTA DE LECTUA O REPO'},
                        { value: 'DESCUENTOS COMERCIALES CONDICIONALES' , label: 'DESCUENTOS COMERCIALES CONDICIONALES'},
                        { value: 'ESTANCIA NO PERTINENTE' , label: 'ESTANCIA NO PERTINENTE'},
                        { value: 'EXAMEN DE LABORATORIO NO INTERPRETADO EN HISTORIA CLINICA' , label: 'EXAMEN DE LABORATORIO NO INTERPRETADO EN HISTORIA CLINICA'},
                        { value: 'FACTURAR DE NUEVO A OTRA ENTIDAD O CLIENTE' , label: 'FACTURAR DE NUEVO A OTRA ENTIDAD O CLIENTE'},
                        { value: 'FRANQUICIAS COPAGOS NO COBRADOS' , label: 'FRANQUICIAS COPAGOS NO COBRADOS'},
                        { value: 'HONORARIOS MEDICOS CAPITADOS' , label: 'HONORARIOS MEDICOS CAPITADOS'},
                        { value: 'IMAGEN DIAGNOSTICA NO INTERPRETADA EN HISTORIA CLINICA' , label: 'IMAGEN DIAGNOSTICA NO INTERPRETADA EN HISTORIA CLINICA'},
                        { value: 'MAL CARGO DE SERVICIO DE AMBULANCIA' , label: 'MAL CARGO DE SERVICIO DE AMBULANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN AMBULANCIA' , label: 'MAYOR VALOR COBRADO EN AMBULANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN CIRUGIA' , label: 'MAYOR VALOR COBRADO EN CIRUGIA' },
                        { value: 'MAYOR VALOR COBRADO EN ESTANCIA' , label: 'MAYOR VALOR COBRADO EN ESTANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN HEMODIALISIS' , label: 'MAYOR VALOR COBRADO EN HEMODIALISIS' },
                        { value: 'MAYOR VALOR COBRADO EN HONORARIOS MEDICO' , label: 'MAYOR VALOR COBRADO EN HONORARIOS MEDICO' },
                        { value: 'MAYOR VALOR COBRADO EN IMÃGENES' , label: 'MAYOR VALOR COBRADO EN IMÃGENES' },
                        { value: 'MAYOR VALOR COBRADO EN INSUMOS Y MEDICAMENTOS' , label: 'MAYOR VALOR COBRADO EN INSUMOS Y MEDICAMENTOS' },
                        { value: 'MAYOR VALOR COBRADO EN LABORATORIO' , label: 'MAYOR VALOR COBRADO EN LABORATORIO' },
                        { value: 'MAYOR VALOR COBRADO EN PROCEDIMIENTOS TE' , label: 'MAYOR VALOR COBRADO EN PROCEDIMIENTOS TE' },
                        { value: 'MAYOR VALOR COBRADO EN UCI' , label: 'MAYOR VALOR COBRADO EN UCI' },
                        { value: 'MAYOR VALOR COBRADO EN URGENCIAS' , label: 'MAYOR VALOR COBRADO EN URGENCIAS' },
                        { value: 'REFACTURA PARCIAL COBERTURA NO ASEGURADA' , label: 'REFACTURA PARCIAL COBERTURA NO ASEGURADA' },
                        { value: 'REFACTURA PARCIAL MEDICAMENTO NO POS' , label: 'REFACTURA PARCIAL MEDICAMENTO NO POS' },
                        { value: 'REFACTURA PARCIAL TOPE MAXIMO POLIZA' , label: 'REFACTURA PARCIAL TOPE MAXIMO POLIZA' },
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE' },	
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE PACIENTE ASEGURADO' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE PACIENTE ASEGURADO' },						
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE' },	
                        { value: 'REFACTURA TOTAL POR FECHA' , label: 'REFACTURA TOTAL POR FECHA' },
                        { value: 'URGENCIA NO VITAL' , label: 'URGENCIA NO VITAL' },
                      ]}
                      meta={{ touched: errors.hasOwnProperty("reason"), error: errors.hasOwnProperty("reason")? errors.reason: "" }}
                  />
                  </div>
                </div>
                <FormMethodPayment 
                  cash={cash} 
                  setCash={setCash} 
                  card={card} 
                  setCard={setCard}
                  check={check} 
                  setCheck={setCheck}
                  wayToPay={wayToPay} 
                  setWayToPay={setWayToPay}
                  errors={errors}
                />
                <div className="form__form-group">
                      <span className="form__form-group-label">
                        Observación
                      </span>
                      <div className="form__form-group-field">
                          <Field
                              name="textarea-observation"
                              component="textarea"
                              type="text"
                              value={observation}
                              onChange={(e) => {
                                  setObservation(e.target.value);
                              }}
                          />
                      </div>
                      <span className="form__form-group-error">
                          { errors.hasOwnProperty("observation")? errors.observation: "" }
                      </span>
                  </div>
                  <div>
                    <Button 
                        style={{ }}
                        variant="contained" 
                        color="primary" 
                        onClick={() => {
                          createDebitNote();
                        }}
                    >
                        Agregar
                    </Button>
                  </div>
              </div>);
      case 'paciente':
        return (<div className="form">
                  <div className="form__form-group">
                      <span className="form__form-group-label">número de documento</span>
                      <div className="form__form-group-field">
                          <Field
                              key={`document-number`}
                              name={`balance`}
                              component={renderField}
                              type="number"
                              placeholder={''}
                              value={documentNumber}
                              onChange={(e) => {
                                  setDocumentNumber(e.target.value);
                              }}
                              meta={errors.hasOwnProperty("documentNumber")? { touched: errors.documentNumber !== '' , error: errors.hasOwnProperty("documentNumber")? errors.documentNumber: ''}: {}}
                          />
                      </div>
                  </div>
                  <div style={{ paddingRight: 5, width: '50%', display: 'flex' }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha desde"
                            views={["year", "month", "date"]}
                            value={dates.start}
                            onChange={(date)=>{
                                setDates({...dates, start: date });
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ marginRight: 10, width: '100%' }}
                        />
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha hasta"
                            views={["year", "month", "date"]}
                            value={dates.end}
                            onChange={(date)=>{
                                setDates({...dates, end: date });
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ width: '100%' }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div style={{ display: 'flex', marginTop: 'auto', marginLeft: '10px'}}>
                  <Button 
                      style={{ margin: 'auto' }}
                      variant="contained" 
                      color="primary" 
                      onClick={() => {
                        searchInvoicesPatient()
                      }}
                  >
                      Buscar Facturas
                  </Button>
                </div>
                  <div className="form__form-group">
                      <span className="form__form-group-label">N° Factura</span>
                      <div className="form__form-group-field">
                      <Field
                          key={`select-invoice-patient`}
                          name={`select-invoice-patient`}
                          component={renderSelectField}
                          value={numBilling}
                          onChange={(event) => {
                              setNumBilling(event);
                          }}
                          options={invoiceOptions}
                          meta={{ touched: errors.hasOwnProperty("numBilling"), error: errors.hasOwnProperty("numBilling")? errors.numBilling: "" }}
                      />
                      </div>
                  </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Motivo</span>
                  <div className="form__form-group-field">
                  <Field
                      key={`select-reason`}
                      name={`select-reason`}
                      component={renderSelectField}
                      value={reason}
                      onChange={(event) => {
                          setReason(event);
                      }}
                      options={[
                        { value: 'AYUDA DIAGNOSTICA NO PERTINENTE' , label: 'AYUDA DIAGNOSTICA NO PERTINENTE'},
                        { value: 'CONCILIACION AUDITORIA MEDICA' , label: 'CONCILIACION AUDITORIA MEDICA'},
                        { value: 'COPAGO NO COBRADO O NODES CONTADO' , label: 'COPAGO NO COBRADO O NODES CONTADO'},
                        { value: 'DESCUENTO 25% POR FALTA DE LECTUA O REPO' , label: 'DESCUENTO 25% POR FALTA DE LECTUA O REPO'},
                        { value: 'DESCUENTOS COMERCIALES CONDICIONALES' , label: 'DESCUENTOS COMERCIALES CONDICIONALES'},
                        { value: 'ESTANCIA NO PERTINENTE' , label: 'ESTANCIA NO PERTINENTE'},
                        { value: 'EXAMEN DE LABORATORIO NO INTERPRETADO EN HISTORIA CLINICA' , label: 'EXAMEN DE LABORATORIO NO INTERPRETADO EN HISTORIA CLINICA'},
                        { value: 'FACTURAR DE NUEVO A OTRA ENTIDAD O CLIENTE' , label: 'FACTURAR DE NUEVO A OTRA ENTIDAD O CLIENTE'},
                        { value: 'FRANQUICIAS COPAGOS NO COBRADOS' , label: 'FRANQUICIAS COPAGOS NO COBRADOS'},
                        { value: 'HONORARIOS MEDICOS CAPITADOS' , label: 'HONORARIOS MEDICOS CAPITADOS'},
                        { value: 'IMAGEN DIAGNOSTICA NO INTERPRETADA EN HISTORIA CLINICA' , label: 'IMAGEN DIAGNOSTICA NO INTERPRETADA EN HISTORIA CLINICA'},
                        { value: 'MAL CARGO DE SERVICIO DE AMBULANCIA' , label: 'MAL CARGO DE SERVICIO DE AMBULANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN AMBULANCIA' , label: 'MAYOR VALOR COBRADO EN AMBULANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN CIRUGIA' , label: 'MAYOR VALOR COBRADO EN CIRUGIA' },
                        { value: 'MAYOR VALOR COBRADO EN ESTANCIA' , label: 'MAYOR VALOR COBRADO EN ESTANCIA' },
                        { value: 'MAYOR VALOR COBRADO EN HEMODIALISIS' , label: 'MAYOR VALOR COBRADO EN HEMODIALISIS' },
                        { value: 'MAYOR VALOR COBRADO EN HONORARIOS MEDICO' , label: 'MAYOR VALOR COBRADO EN HONORARIOS MEDICO' },
                        { value: 'MAYOR VALOR COBRADO EN IMÃGENES' , label: 'MAYOR VALOR COBRADO EN IMÃGENES' },
                        { value: 'MAYOR VALOR COBRADO EN INSUMOS Y MEDICAMENTOS' , label: 'MAYOR VALOR COBRADO EN INSUMOS Y MEDICAMENTOS' },
                        { value: 'MAYOR VALOR COBRADO EN LABORATORIO' , label: 'MAYOR VALOR COBRADO EN LABORATORIO' },
                        { value: 'MAYOR VALOR COBRADO EN PROCEDIMIENTOS TE' , label: 'MAYOR VALOR COBRADO EN PROCEDIMIENTOS TE' },
                        { value: 'MAYOR VALOR COBRADO EN UCI' , label: 'MAYOR VALOR COBRADO EN UCI' },
                        { value: 'MAYOR VALOR COBRADO EN URGENCIAS' , label: 'MAYOR VALOR COBRADO EN URGENCIAS' },
                        { value: 'REFACTURA PARCIAL COBERTURA NO ASEGURADA' , label: 'REFACTURA PARCIAL COBERTURA NO ASEGURADA' },
                        { value: 'REFACTURA PARCIAL MEDICAMENTO NO POS' , label: 'REFACTURA PARCIAL MEDICAMENTO NO POS' },
                        { value: 'REFACTURA PARCIAL TOPE MAXIMO POLIZA' , label: 'REFACTURA PARCIAL TOPE MAXIMO POLIZA' },
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE' },	
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE PACIENTE ASEGURADO' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE PACIENTE ASEGURADO' },						
                        { value: 'REFACTURA TOTAL CAMBIO DE CLIENTE' , label: 'REFACTURA TOTAL CAMBIO DE CLIENTE' },	
                        { value: 'REFACTURA TOTAL POR FECHA' , label: 'REFACTURA TOTAL POR FECHA' },
                        { value: 'URGENCIA NO VITAL' , label: 'URGENCIA NO VITAL' },
                      ]}
                      meta={{ touched: errors.hasOwnProperty("reason"), error: errors.hasOwnProperty("reason")? errors.reason: "" }}
                  />
                  </div>
                </div>
                <FormMethodPayment 
                  cash={cash} 
                  setCash={setCash} 
                  card={card} 
                  setCard={setCard}
                  check={check} 
                  setCheck={setCheck}
                  wayToPay={wayToPay} 
                  setWayToPay={setWayToPay}
                  errors={errors}
                />
                <div className="form__form-group">
                      <span className="form__form-group-label">
                        Observación
                      </span>
                      <div className="form__form-group-field">
                          <Field
                              name="textarea-observation"
                              component="textarea"
                              type="text"
                              value={observation}
                              onChange={(e) => {
                                  setObservation(e.target.value);
                              }}
                          />
                      </div>
                      <span className="form__form-group-error">
                          { errors.hasOwnProperty("observation")? errors.observation: "" }
                      </span>
                  </div>
                  <div>
                    <Button 
                        style={{ }}
                        variant="contained" 
                        color="primary" 
                        onClick={() => {
                          createDebitNote()
                        }}
                    >
                        Agregar
                    </Button>
                  </div>
              </div>);
      default: 
        return null;  
    }
  }

const AddDebitNote = (props) => {
        const [ type, setType ]= useState(null);
        const [ numNota, setNumNota ] = useState(null);
        const [ numBilling, setNumBilling ] = useState(null);
        const [ invoiceList, setInvoiceList ] = useState([]);
        const [ cash, setCash ] = useState("");
        const [ card, setCard ] = useState("");
        const [ check, setCheck ] = useState("");
        const [ wayToPay, setWayToPay ] = useState("");
        const [ balance, setBalance ] = useState('');
        const [ observation, setObservation ] = useState('');
        const [ costumers, setCostumers ] = useState([]);
        const [ costumer, setCostumer ] = useState();
        const [ reason, setReason ] = useState(null);
        const [ dates, setDates ] = useState({ start: new Date(), end: new Date() })
        const [ errors, setErrors ] = useState({});
        const [ load , setLoad] = useState(true);
        const [ documentNumber, setDocumentNumber ] = useState('');

        useEffect(()=>{
            if(props.location.state.numNota != 0 ){
                setNumNota(props.location.state.numNota);
                //loadDataDebitNote();
            }
            loadCostumer();
            
        }, []);

        const loadDataDebitNote = () => {
            var data = { num_notac: numNota }
            fetch( process.env.REACT_APP_PUBLIC_URL + 'facturas/consultarndebito',  {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
                },
                body: JSON.stringify(data)
              })
              .then(response => {
                return response.json();
              })
              .then(data => {
                console.log(data);
                if(data.existe){
                    console.log(data.contenido[0]);
                    
                } else {

                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
        }

        const loadCostumer = () => {
          fetch( process.env.REACT_APP_PUBLIC_URL + 'tercero/listar',  {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
              }
            })
            .then(response => {
              return response.json();
            })
            .then(data => {
              console.log(data);
              setCostumers(data);
              setLoad(false);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
      }

      const loadInvoices = (type) => {
        var url = process.env.REACT_APP_PUBLIC_URL; 
        var data = {};
        if(type.value === "cliente"){
          url = url + + 'facturastercero/consultarind'
          data.num_fact_ter = 1;
        } else if(type.value == "paciente") {
          url = url + + 'facturas/consultar';
          data.num_fac_pac = 1;
        }
        
        fetch(url,  
            {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
              },
              body: JSON.stringify(data)
            })
            .then(response => {
              return response.json();
            })
            .then(data => {
              console.log(data);
              if(data.existe){
                  console.log(data.contenido[0]);
                  
              } else {

              }
            })
            .catch((error) => {
              console.error('Error:', error);
            })
      }

      const searchInvoicesCostumer = (type) => {

        var data =  {
            num_fac_ter: "", 
            id_tercero: costumer.value,
            desde:  moment(dates.start).format("YYYY-MM-DD"),
            hasta: moment(dates.end).format("YYYY-MM-DD")
          };
        console.log(data);
        fetch( process.env.REACT_APP_PUBLIC_URL + 'facturastercero/ver',  
        {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if(data.existe){
              console.log(data.contenido[0]);
              setInvoiceList(data.contenido)
          } else {
              alert(data.contenido);
              setInvoiceList([])
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      const searchInvoicesPatient = () => {
        var data =  {
          num_fac_pac: "", 
          num_documento: documentNumber,
          desde:  moment(dates.start).format("YYYY-MM-DD"),
          hasta: moment(dates.end).format("YYYY-MM-DD")
        };
        console.log(data);
        fetch( process.env.REACT_APP_PUBLIC_URL + 'facturas/ver',  
        {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if(data.existe){
              console.log(data.contenido[0]);
              setInvoiceList(data.contenido)
          } else {
              alert(data.contenido);
              setInvoiceList([])
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

     const validate = () => {
        var errors = {};
        if(numBilling === null){
          errors.numBilling = "Seleccione una factura, use el buscador para encontrar un factura valida";
        } else {
          delete errors.numBilling;
        }

        if(reason == null){
          errors.reason = "Seleccione una razón para la nota";
        } else {
          delete errors.reason; 
        }

        if(card !== '' && wayToPay === ''){
            errors.wayToPay = "Seleccione una forma de pago de tarjeta";
        } else {
            delete errors.wayToPay;
        }
      
        if(parseInt(cash !== ""? cash: "0") + parseInt(card !== ""? card: "0") + parseInt(check !== ""? check: "0") === 0){
            errors.total = "Seleccione un medio de pago";
        } else {
            delete errors.total;
        }

        if(observation === ""){
          errors.observation = "Agrege una observación";
        } else {
          delete errors.observation; 
        }

        setErrors(errors);
        console.log(errors);
        if(Object.keys(errors).length == 0){
            return false;
        } else {
            return true;
        }

      }

      const createDebitNote = () => {
        if(!validate()){
          var paymentType = "";
          if(cash !== "" && cash !== NaN){
            paymentType += `Efectivo`;
          }
          if(card !== "" && card !== NaN){
              paymentType += `${paymentType !== ""? ", tarjeta": "tarjeta"}`
          }
          if(check !== "" && check !== NaN){
              paymentType += `${paymentType !== ""? ", cheque": "cheque"}`
          }
          var data = {  
                        num_fact: numBilling.value,
                        fecha_emision:  moment(new Date()).format("YYYY-MM-DD"),
                        forma_pago: paymentType,
                        monto: parseInt(cash !== ""? cash: "0") + parseInt(card !== ""? card: "0") + parseInt(check !== ""? check: "0"),
                        moneda: "COP",
                        observaciones: observation,
                        motivo: reason.value
                      }
  
          if(type.value == 'cliente'){
            data.cliente = 'Tercero';
          } else if(type.value === 'paciente'){
            data.cliente = 'Paciente';
          }
  
            var medio_pago = []
            if(cash !== "" && cash !== NaN){
                medio_pago.push({ medio: "Efectivo", monto: parseInt(cash) })
            }
            if(card !== "" && card !== NaN){
                if(wayToPay.value == "DEBITO"){
                    medio_pago.push({ medio: "Debito", monto: parseInt(card) })
                } else if (wayToPay.value === "CREDITO"){
                    medio_pago.push({ medio: "Credito", monto: parseInt(card) })
                } 
            }
            if(check !== "" && check !== NaN){
                medio_pago.push({ medio: "Cheque", monto: parseInt(check) })
            }
            console.log(medio_pago);
            data.medio_pago = medio_pago;
            console.log(data);

            fetch( process.env.REACT_APP_PUBLIC_URL + 'facturas/ndebito',  
              {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
                },
                body: JSON.stringify(data)
              })
              .then(response => {
                return response.json();
              })
              .then(data => {
                console.log(data);
                alert(data.mensaje);
                var xml = BuildXml(data, "ND", type.value == "cliente"? "CLIENTE": "PACIENTE");
                console.log(xml);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
        }
      }

        const { classes } = props;

        return (<Container className="dashboard">
                    <Row>
                        <Col md={12}>
                            <h3 style={{ marginBottom: 30 }}>Crear Nota Debito</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Card>
                            <CardBody>
                            <div className="form__form-group">
                                <span className="form__form-group-label">tipo de factura</span>
                                <div className="form__form-group-field">
                                <Field
                                    name="select-type-billing"
                                    component={renderSelectField}
                                    value={type}
                                    onChange={(event) => {
                                        setType(event);
                                        console.log(event);
                                    }}
                                    options={[
                                        { value: 'cliente', label: 'Cliente' },
                                        { value: 'paciente', label: 'Paciente' },
                                    ]}
                                />
                                </div>
                            </div>
                            {!load && type !== null ? 
                                            <TypeForm 
                                              type={type.value} 
                                              setType={setType} 
                                              costumer={costumer}
                                              setCostumer={setCostumer}
                                              costumers={costumers} 
                                              reason={reason}
                                              setReason={setReason}
                                              invoiceList={invoiceList}
                                              numBilling={numBilling}
                                              setNumBilling={setNumBilling} 
                                              balance={balance}
                                              setBalance={setBalance}
                                              observation={observation} 
                                              setObservation={setObservation} 
                                              errors={errors} 
                                              documentNumber={documentNumber}
                                              setDocumentNumber={setDocumentNumber}
                                              cash={cash} 
                                              setCash={setCash} 
                                              card={card} 
                                              setCard={setCard}
                                              check={check} 
                                              setCheck={setCheck}
                                              wayToPay={wayToPay} 
                                              setWayToPay={setWayToPay}
                                              dates={dates}
                                              setDates={setDates}
                                              searchInvoicesCostumer={searchInvoicesCostumer}
                                              searchInvoicesPatient={searchInvoicesPatient}
                                              createDebitNote={createDebitNote}
                                            />: null}
                          </CardBody>
                        </Card>
                    </Row>
                </Container>);
}

export default reduxForm({
    form: 'add_debit_note_form', // a unique identifier for this form
})(withStyles(styles, { withTheme: true })(withTranslation('common')(AddDebitNote)));

